import { useState } from 'react';
import { Github, ExternalLink } from 'lucide-react';

// Import project images
import aiLearningImg from '../assets/imag4e.png';
import codeVerseImg from '../assets/image3.png';
import newsAnalyzerImg from '../assets/image2.png';
import portfolioImg from '../assets/image1.png';
import porf from '../assets/imag4e.png';
import p from '../assets/image.png';

export default function Projects() {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'AI Learning Assistant',
      description: 'An intelligent learning assistant powered by AI to help students learn more effectively. Features personalized learning paths, progress tracking, and interactive quizzes.',
      image: 'https://fsspmzxvfjnvtqnuutsp.supabase.co/storage/v1/object/public/tool-images/screenshots/learn-place-ai-learning-assistant.jpg',
      category: 'fullstack',
      technologies: ['React', 'Node.js', 'MongoDB', 'AI/ML'],
      github: 'https://github.com/l0kesh-y/AI-LEARNING_ASSISTANT',
      live: 'https://ai-learning-assistant-cu4a.onrender.com'
    },
    {
      id: 2,
      title: 'CodeVerse AI',
      description: 'An AI-powered code analysis and generation platform. Helps developers write better code with intelligent suggestions and automated code reviews.',
      image: portfolioImg,
      category: 'fullstack',
      technologies: ['React', 'Node.js', 'AI API', 'Express'],
      github: 'https://github.com/l0kesh-y/CodeVerse_AI',
      live: 'https://codeverse-ai-lokesh.onrender.com'
    },
    {
      id: 3,
      title: 'AI News Analyzer',
      description: 'Real-time news analysis platform using AI to categorize, summarize, and analyze news sentiment. Features automated content processing and trend detection.',
      image: newsAnalyzerImg,
      category: 'fullstack',
      technologies: ['Node.js', 'Express', 'AI/ML', 'MongoDB'],
      github: 'https://github.com/l0kesh-y/ai-news-analyzer',
      live: 'https://ai-newsanalyzer.onrender.com'
    },
    {
      id: 4,
      title: 'Portfolio Website',
      description: 'Modern, responsive portfolio website with dark/light theme toggle, smooth animations, and contact form integration. Built with React and deployed on Netlify.',
      image: porf,
      category: 'frontend',
      technologies: ['React', 'CSS3', 'JavaScript', 'Netlify'],
      github: 'https://github.com/l0kesh-y/main-portfolio',
      live: 'https://lokesh-y.netlify.app'
    },
    {
      id: 5,
      title: 'ChatApp',
      description: 'Full-stack e-commerce application with user authentication, product catalog, shopping cart, payment integration, and order management system.',
      image: p,
      category: 'fullstack',
      technologies: ['React', 'Springboot'],
      github: 'https://github.com/l0kesh-y/SpringChatApp',
      live: 'https://github.com/l0kesh-y/SpringChatApp'
    },
    {
      id: 6,
      title: 'B2C - Sympo Event',
      description: 'Collaborative task management application with real-time updates, team collaboration features, and progress tracking. Includes role-based access control.',
      image: codeVerseImg,
      category: 'fullstack',
      technologies: ['HTML', 'Socket.io', 'Node.js', 'PostgreSQL'],
      github: 'https://github.com/Lokesh777777/task-manager',
      live: 'https://sympo-web.onrender.com/'
    }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <div className="page projects-page">
      <div className="projects-header">
        <br/>
        <br/>
        <h1>My Projects</h1>
        <p>Here are some of my recent works</p>
      </div>

      <div className="filter-buttons">
        <button 
          className={filter === 'all' ? 'active' : ''}
          onClick={() => setFilter('all')}
        >
          All
        </button>
        <button 
          className={filter === 'frontend' ? 'active' : ''}
          onClick={() => setFilter('frontend')}
        >
          Frontend
        </button>
        <button 
          className={filter === 'backend' ? 'active' : ''}
          onClick={() => setFilter('backend')}
        >
          Backend
        </button>
        <button 
          className={filter === 'fullstack' ? 'active' : ''}
          onClick={() => setFilter('fullstack')}
        >
          Full Stack
        </button>
      </div>

      <div className="projects-grid">
        {filteredProjects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-image">
              <img src={project.image} alt={project.title} />
              <div className="project-overlay">
                <div className="project-links">
                  <a href={project.github} target="_blank" rel="noopener noreferrer" aria-label="View GitHub repository">
                    <Github size={20} />
                  </a>
                  <a href={project.live} target="_blank" rel="noopener noreferrer" aria-label="View live project">
                    <ExternalLink size={20} />
                  </a>
                </div>
              </div>
            </div>
            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}